import React, { useRef, useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import TicketMessageInput from "./TicketMessageInput";
import ChatMessageFooter from "../../ChatComponents/ChatMessageFooter";
import { Avatar } from "@mui/material";
import { ReactComponent as Circle } from "../../../../assets/images/circle.svg";
import { colorCodesForAvatar } from "../../../../constants/index";
import {
  chracterPosition,
  formatTicketMessageContent,
} from "../../../../utils/index";
import { useSelector } from "react-redux";
import "./style.css";
import MessageTranscript from "../TicketChatSection/MessageTranscript";
import ReactMarkdown from "react-markdown";
import AuditTrail from "./AuditTrail";

function TicketMessageContainer({
  setSelectedState,
  setActiveTicketMerge,
  messages,
  createdAt,
  ticketStatus,
  socketInstance,
  assignedAgent,
  transcriptMessages,
  ticket,
  customerEmail,
  customerName,
  composerVariant = "default",
  selectedGroupId,
}) {
  const messageContainerRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  const [searchParams] = useSearchParams();
  const ticketId = searchParams.get("ticketId");
  const userData = useSelector((state) => state.loginToken);
  const agentImage = userData?.response?.user?.agent_image;
  const agentName = userData?.response?.user?.full_name;
  const role = userData?.response?.user?.role_name;

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState("");
  const [hasScroll, setHasScroll] = useState(false);
  const setMultipleRefs = (el) => {
    messageContainerRef.current = el;
    scrollWrapperRef.current = el;
  };
  const checkForScroll = () => {
    if (scrollWrapperRef.current) {
      const { scrollHeight, clientHeight } = scrollWrapperRef.current;
      setHasScroll(scrollHeight > clientHeight);
    }
  };

  const openFullScreen = (src) => {
    setModalImageSrc(src);
    setModalOpen(true);
  };

  const closeFullScreen = () => {
    setModalOpen(false);
    setModalImageSrc("");
  };

  useEffect(() => {
    if (isModalOpen) {
      const handleKeyDown = (e) => {
        if (e.key === "Escape") closeFullScreen();
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
    checkForScroll();
  }, [messages]);

  useEffect(() => {
    const handleResize = () => {
      checkForScroll();
    };

    window.addEventListener("resize", handleResize);

    checkForScroll();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const msgTime = (time, isMessageTimeStamp) => {
    const date = new Date(time);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
    const timeString = date
      .toLocaleTimeString(undefined, timeOptions)
      .replace(/\s?(AM|PM)/gi, (match) => match.toLowerCase());

    if (isToday || isMessageTimeStamp) {
      return timeString;
    }

    const dateOptions = { year: "numeric", month: "short", day: "2-digit" };
    const dateString = date.toLocaleDateString(undefined, dateOptions);

    return `${dateString} ${timeString}`;
  };

  const TIME_THRESHOLD = 15 * 60 * 1000;

  const sortedMessages = [...messages].sort((a, b) => {
    const timeA = new Date(a?.created_at).getTime() || 0;
    const timeB = new Date(b?.created_at).getTime() || 0;

    if (timeA !== timeB) return timeA - timeB;

    // same timestamp → keep order in array (no further sorting)
    return 0;
  });

  return (
    <div className="ChatMessageComponent-Container-Ticket">
      {isModalOpen && (
        <div
          className="modal"
          onClick={closeFullScreen}
          style={{ zIndex: 9999 }}
        >
          <span
            onClick={closeFullScreen}
            className="modal-close"
            style={{
              position: "absolute",
              top: 20,
              right: 30,
              fontSize: 40,
              color: "#fff",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            &times;
          </span>
          <img
            src={modalImageSrc}
            className="modal-image"
            alt="Fullscreen"
            style={{
              display: "block",
              maxWidth: "90vw",
              maxHeight: "90vh",
              margin: "60px auto 0",
              borderRadius: 8,
              boxShadow: "0 2px 16px rgba(0,0,0,0.4)",
              background: "#fff",
              zIndex: 10000,
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      <div className="MessageComponet-Main">
        <div
          className="TicketMessageComponent-Main-02"
          style={
            composerVariant === "tv2"
              ? undefined
              : { paddingRight: hasScroll ? "10px" : "16px" }
          }
        >
          <div className="scroll-wrapper" ref={setMultipleRefs}>
            {/* <div className="Message-Time-Header">
              <span className="Left-Line" />
              <p className="Message-Time-Text">
                Ticket Assigned to{" "}
                <span
                  style={{
                    color: " #061522",
                    textAlign: "right",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "12px",
                  }}
                >
                  {assignedAgent || "N/A"}
                </span>
              </p>
              <span className="right-Line" />
            </div> */}

            {ticket?.isFromWidget && (
              <div className="Ticket-Message-Container ticket-user-message">
                <Avatar
                  style={{ margin: 0, width: "32px", height: "32px" }}
                  className="ticket-user-avatar"
                  sx={{
                    bgcolor:
                      colorCodesForAvatar[
                        chracterPosition(
                          (ticket.customerName || customerName || "User")
                            .substring(0, 1)
                            .toUpperCase(),
                        )
                      ] || "#757575", // Fallback to darker gray if undefined
                  }}
                >
                  {(ticket.customerName || customerName || "User")
                    .substring(0, 1)
                    .toUpperCase()}
                </Avatar>
                <div className="ticket-message-content-wrapper">
                  <div className={"ticket-user-content"}>
                    {ticket?.description && (
                      <div className="ticket-message-text-container">
                        <div className="ticket-message-content">
                          <p
                            style={{ color: "#061522" }}
                            className="ticket-message-text"
                          >
                            {ticket?.description}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="ticket-message-time">
                    <p className={"ticket-user-time"}>
                      {composerVariant !== "tv2" && (
                        <span
                          style={{
                            color: "#061522",
                            textAlign: "right",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            textTransform: "capitalize",
                            lineHeight: "12px",
                          }}
                        >
                          {ticket?.customerName}
                        </span>
                      )}{" "}
                      {msgTime(ticket?.created_at || ticket?.createdAt, true)}
                    </p>
                  </div>
                </div>
              </div>
            )}
            {ticket?.chatRoom && (
              <MessageTranscript
                messages={transcriptMessages}
                name={customerName || "N/A"}
                email={customerEmail || "N/A"}
                createdAt={createdAt || ticket?.created_at}
              />
            )}

            {sortedMessages.map((message, index) => {
              // Ensure we have a valid timestamp
              const currentTime = new Date(message.created_at);
              const previousTime =
                index > 0
                  ? new Date(sortedMessages[index - 1].created_at)
                  : null;

              // Show time header if there's a significant gap between messages
              const showTimeHeader =
                index !== 0 &&
                previousTime &&
                !isNaN(currentTime.getTime()) &&
                !isNaN(previousTime.getTime()) &&
                currentTime.getTime() - previousTime.getTime() > TIME_THRESHOLD;

              const isAgent = message.type === "agent";
              const isAdmin = message.isAdmin === true;
              const messageAgent = message.agent || {};
              const currentUserId = userData?.response?.user?._id;
              const isCurrentUserSender =
                Boolean(currentUserId) &&
                (messageAgent._id === currentUserId ||
                  message.senderId === currentUserId ||
                  message.sender === agentName);
              const isAssigneeSender =
                Boolean(ticket?.assignee) &&
                (messageAgent._id === ticket.assignee._id ||
                  message.sender === ticket.assignee.full_name);
              // Always prefer the message sender's image; only use the logged-in
              // user's image when they are the sender of this message.
              const agentProfileImage =
                messageAgent.agent_image ||
                message.agentProfileImage ||
                message.senderImage ||
                (isCurrentUserSender ? agentImage : null) ||
                (isAssigneeSender ? ticket?.assignee?.agent_image : null) ||
                null;
              const agentFullName =
                messageAgent.full_name ||
                message.sender ||
                (isCurrentUserSender ? agentName : "") ||
                "";

              // Generate a more reliable unique key
              const messageKey =
                message._id ||
                message.id ||
                `${index}-${currentTime.getTime()}`;

              return (
                <React.Fragment key={messageKey}>
                  {showTimeHeader && (
                    <div
                      style={{ margin: "10px", gap: 0 }}
                      className="Message-Time-Header"
                    >
                      <span className="Left-Line" />
                      <p className="Message-Time-Text">
                        {msgTime(currentTime)}
                      </p>
                      <span className="right-Line" />
                    </div>
                  )}

                  <AuditTrail message={message} agentName={agentName} />

                  {message.type !== "status_change" &&
                    message.type !== "events" && (
                      <div
                        className={`Ticket-Message-Container ${
                          isAgent
                            ? "ticket-agent-message"
                            : "ticket-user-message"
                        }`}
                      >
                        {/* Avatar */}
                        {!isAgent ? (
                          <Avatar
                            className="ticket-user-avatar"
                            sx={{
                              width: 32,
                              height: 32,
                              bgcolor:
                                colorCodesForAvatar[
                                  chracterPosition(
                                    (
                                      ticket?.customerName ||
                                      customerName ||
                                      "User"
                                    )
                                      .substring(0, 1)
                                      .toUpperCase(),
                                  )
                                ] || "#757575", // Fallback to darker gray if undefined
                            }}
                          >
                            {(ticket?.customerName || customerName || "User")
                              .substring(0, 1)
                              .toUpperCase()}
                          </Avatar>
                        ) : agentProfileImage ? (
                          <Avatar
                            sx={{ width: 32, height: 32 }}
                            className="ticket-agent-avatar"
                            src={agentProfileImage}
                            alt={agentFullName}
                          />
                        ) : (
                          <Avatar
                            className="ticket-agent-avatar"
                            sx={{
                              width: 32,
                              height: 32,
                              bgcolor:
                                colorCodesForAvatar[
                                  chracterPosition(
                                    (agentFullName || "A")
                                      .substring(0, 1)
                                      .toUpperCase(),
                                  )
                                ] || "#757575", // Fallback to darker gray if undefined
                            }}
                          >
                            {(agentFullName || "A").substring(0, 1).toUpperCase()}
                          </Avatar>
                        )}

                        {/* Message content */}
                        <div className="ticket-message-content-wrapper">
                          <div
                            className={
                              isAgent
                                ? message.isPrivate
                                  ? "ticket-admin-content"
                                  : "ticket-agent-content"
                                : "ticket-user-content"
                            }
                          >
                            {/* Text message */}
                            {message.message && (
                              <div className="ticket-message-text-container">
                                <div className="ticket-message-content">
                                  <div className="ticket-message-text">
                                    <ReactMarkdown
                                      components={{
                                        a: ({ node, ...props }) => (
                                          <a
                                            {...props}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              color: `${isAgent ? "#ffffffff" : "#007bff"}`,
                                              textDecoration: "underline",
                                            }}
                                          />
                                        ),
                                      }}
                                    >
                                      {formatTicketMessageContent(
                                        message.message
                                      )}
                                    </ReactMarkdown>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Single image */}
                            {message.file_image &&
                              !message.attachments?.length && (
                                <div className="ticket-image-container">
                                  <img
                                    src={message.file_image}
                                    alt="Attached"
                                    className="ticket-message-image"
                                    onClick={() =>
                                      openFullScreen(message.file_image)
                                    }
                                  />
                                </div>
                              )}

                            {/* Attachments */}
                            {message.attachments &&
                              message.attachments.length > 0 && (
                                <div className="ticket-attachments-container">
                                  {message.attachments.map(
                                    (attachment, attachIndex) => (
                                      <div
                                        key={attachment._id || attachIndex}
                                        className="ticket-attachment-item"
                                      >
                                        {(!attachment.mimeType ||
                                          attachment.mimeType.startsWith(
                                            "image/",
                                          )) && (
                                          <div className="ticket-image-container">
                                            <img
                                              src={attachment.url}
                                              alt={
                                                attachment.filename ||
                                                "Attached image"
                                              }
                                              className="ticket-message-image"
                                              onClick={() =>
                                                openFullScreen(attachment.url)
                                              }
                                              loading="lazy"
                                            />
                                            {attachment.filename && (
                                              <div className="ticket-attachment-filename">
                                                {attachment.filename}
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        {attachment.mimeType &&
                                          !attachment.mimeType.startsWith(
                                            "image/",
                                          ) && (
                                            <div className="ticket-file-container">
                                              <a
                                                href={attachment.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="ticket-file-link"
                                              >
                                                {attachment.filename} (
                                                {
                                                  attachment.mimeType.split(
                                                    "/",
                                                  )[1]
                                                }
                                                )
                                              </a>
                                            </div>
                                          )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                          </div>

                          {/* Time */}
                          <div className="ticket-message-time">
                            <p
                              className={
                                isAgent
                                  ? "ticket-agent-time"
                                  : "ticket-user-time"
                              }
                            >
                              {composerVariant !== "tv2" && (
                              <span
                                style={{
                                  color: "#061522",
                                  textAlign: "right",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "12px",
                                }}
                              >
                                  {message.type === "agent" && message.sender}
                                </span>
                              )}{" "}
                              {msgTime(message.created_at, true)}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>

      <div className="ChatMessage_Container_Input">
        <TicketMessageInput
          ticketId={ticketId}
          setSelectedState={setSelectedState}
          setActiveTicketMerge={setActiveTicketMerge}
          messageContainerRef={messageContainerRef}
          isDisabled={ticketStatus === "solved" || ticketStatus === "spam"}
          socketInstance={socketInstance}
          ticket={ticket}
          ticketStatus={ticketStatus}
          variant={composerVariant}
          selectedGroupId={selectedGroupId}
        />
      </div>
      {composerVariant !== "tv2" && (
        <div className="ticketmessage-footer">
          <ChatMessageFooter isFromTicket={true} />
        </div>
      )}
    </div>
  );
}

export default TicketMessageContainer;
